/**
 * Service to detect browser API availability
 */
class Features {
  /** Detects geolocation support */
  geolocation(): boolean {
    return 'geolocation' in navigator;
  }

  /** Detects touch support */
  touch(): boolean {
    return 'ontouchstart' in window || !!navigator.maxTouchPoints;
  }

  isDialogElementSupported() {
    return 'function' == typeof HTMLDialogElement;
  }

  isShareSupported(): boolean {
    return 'share' in navigator;
  }
}

export default new Features();
